
































import { SpotWidgetDataMixin } from '@/features/core/components/spot-widget-control/data-mixin';
import { ContinuousMetricPoint } from '@/features/core/util/metrics';
import { range } from 'lodash';
import { Component, Mixins } from 'vue-property-decorator';
import bgImage from './quad-heating-lg.svg';

interface HeatingMetric {
  index: number;
  name: string;
  point?: ContinuousMetricPoint;
  serial?: string;
  position: number;
}

@Component
export default class QuadHeatingDevicePanel extends Mixins(SpotWidgetDataMixin) {
  private backgroundImage = bgImage;

  private get heatingMetrics(): HeatingMetric[] {
    return range(1, 5)
      .map((index) => ({
        index,
        name: `heating${index}`,
        point: this.metrics.continuous[`heating${index}`],
        serial: this.metrics.discrete[`externalProbeSerialNumber${index}`]?.value,
        position:
          this.spot?.metricConfigurations.find(({ name }) => name === `heating${index}`)?.position ?? Number.MAX_VALUE,
      }))
      .sort((a, b) => a.position - b.position || a.index - b.index);
  }
}
